import api from './api';

const filiereService = {
  // Routes publiques
  getAll: () => {
    return api.get('/filieres');
  },

  getBySlug: (slug) => {
    return api.get(`/filieres/${slug}`);
  },

  // Routes admin
  admin: {
    getAll: () => {
      return api.get('/admin/filieres');
    },

    getById: (id) => {
      return api.get(`/admin/filieres/${id}`);
    },

    create: (data) => {
      return api.post('/admin/filieres', data);
    },

    update: (id, data) => {
      return api.put(`/admin/filieres/${id}`, data);
    },

    delete: (id) => {
      return api.delete(`/admin/filieres/${id}`);
    },

    getStatistiques: () => {
      return api.get('/admin/filieres/statistiques');
    }
  }
};

export default filiereService;
